import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate, // Adicionei Navigate aqui
} from 'react-router-dom';
// import { useAuthStore } from './store/authStore'; // Comentado - não usado se rotas protegidas forem inativas
import ScrollToTop from './layouts/ScrollToTop';
import ScrollToTopButton from './layouts/ScrollToTopButton';
import { ThemeProvider } from './context/ThemeContext';
import ChatBot from './components/ChatBot/ChatBot';

// Dynamic loading of components
// Comentadas as rotas que não serão mais usadas para a página principal
// const PublicLayout = React.lazy(() => import('./layouts/PublicLayout'));
// const PersonalLayout = React.lazy(() => import('./layouts/PersonalLayout'));
const ImprintLayout = React.lazy(() => import('./layouts/ImprintLayout'));
// const AboutLayout = React.lazy(() => import('./layouts/AboutLayout'));
// const PrivacyLayout = React.lazy(() => import('./layouts/PrivacyLayout'));
// const PrivateLayout = React.lazy(() => import('./layouts/PrivateLayout'));
// const LoginForm = React.lazy(() => import('./components/auth/LoginForm'));
// const Dashboard = React.lazy(() => import('./components/dashboard/Dashboard'));
// const ServiceLayout = React.lazy(() => import('./layouts/ServicesLayout'));
// const FeaturesLayout = React.lazy(() => import('./layouts/FeaturesLayout'));

// Protected route - Comentado, pois não haverá rotas protegidas
// const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
//   const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
//   return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
// };

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <div style={{ marginTop: '64px' }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              {/* Public routes - Rotas comentadas para manter apenas a /imprint */}
              {/* <Route path="/" element={<PersonalLayout />} /> */}
              {/* <Route path="/business" element={<PublicLayout />} /> */}
              {/* <Route path="/login" element={<LoginForm />} /> */}
              {/* <Route path="/services" element={<ServiceLayout />} /> */}
              {/* <Route path="/features" element={<FeaturesLayout />} /> */}
              <Route path="/imprint" element={<ImprintLayout />} />
              {/* <Route path="/about" element={<AboutLayout />} /> */}
              {/* <Route path="/privacy" element={<PrivacyLayout />} /> */}

              {/* Rota de redirecionamento para TODAS as outras URLs */}
              <Route path="*" element={<Navigate to="/imprint" replace />} />

              {/* Protected routes - Comentadas */}
              {/* <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <PrivateLayout>
                      <Dashboard />
                    </PrivateLayout>
                  </ProtectedRoute>
                }
              /> */}
            </Routes>
          </Suspense>
        </div>
        {/* Scroll-to-Top-Button */}
        <ScrollToTopButton />
        {/* ChatBot */}
        <ChatBot />
      </Router>
    </ThemeProvider>
  );
}

export default App;